module.exports = __webpack_public_path__ + "img/sttr.d6563e01.png";